import { PendingRememberMeChoiceKey, RcmUserCookieName, emailPattern } from '../../../shared/Constants'
import { deleteCookie, getCookie, setCookie } from '../../../shared/utilities/Cookies'
import { CryptoUtil } from '../../../shared/utilities/CryptoUtil'
import { getSessionStorage, removeSessionStorage, setSessionStorage } from '../../../shared/utilities/Session'
import { Logger } from '../../../system/appinsights/Logger'

interface IPendingRememberMeChoice {
  remember: boolean
  email: string
}

export class LoginUtility {
  static SetLoginEmailToCookie = (data: string) => {
    const encryptedData = CryptoUtil.encrypt(data)
    setCookie(RcmUserCookieName, encryptedData, 365)
  }

  static GetLoginEmailFromCookie = () => {
    const cipherText = getCookie(RcmUserCookieName)
    const email = CryptoUtil.decrypt(cipherText)
    const isValidEmail = emailPattern.test(email)
    return isValidEmail ? email : ''
  }

  static DeleteLoginEmailCookie = () => {
    deleteCookie(RcmUserCookieName)
  }

  // Holds the remember-me choice until MSAL confirms login succeeded; encrypted since it carries the email
  static StagePendingRememberMeChoice = (remember: boolean, email: string) => {
    const choice: IPendingRememberMeChoice = { remember, email }
    setSessionStorage(PendingRememberMeChoiceKey, CryptoUtil.encrypt(JSON.stringify(choice)))
  }

  // Commits the staged choice to the cookie after a successful login; never throws so login completion continues
  static ApplyPendingRememberMeChoice = () => {
    const cipherText = getSessionStorage(PendingRememberMeChoiceKey)
    removeSessionStorage(PendingRememberMeChoiceKey)
    if (!cipherText) {
      return
    }
    try {
      const choice = JSON.parse(CryptoUtil.decrypt(cipherText)) as Partial<IPendingRememberMeChoice> | null
      if (typeof choice?.remember !== 'boolean' || typeof choice.email !== 'string') {
        return
      }
      choice.remember ? LoginUtility.SetLoginEmailToCookie(choice.email) : LoginUtility.DeleteLoginEmailCookie()
    } catch {
      Logger.LogException({ message: 'Invalid pending remember-me state', exceptionType: 'LOGIN_STATE' })
    }
  }

  // Discards the staged choice without touching the cookie (login failed or never completed)
  static ClearPendingRememberMeChoice = () => {
    removeSessionStorage(PendingRememberMeChoiceKey)
  }
}
